<template>
  <div>
    <div
        v-if="detail_loader"
        style="position:absolute; top:0; right:0; bottom:0; left:0; padding-top: 25%;background-color:rgba(255,255,255,0.31)"
    >
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>
    <v-container>
      <v-layout row wrap>
        <v-flex sm12 md12 lg3>
          <router-link to="/Ecart-Booking-list">
            <v-card
                class="mx-auto"
                max-width="340">
              <v-span style="font-size: 500%;margin:20px;color:#A52A2A;"></v-span>
              <v-card-title>
                <v-icon color="#bbbbc6" class="black--text mr-2">shopping_cart
                </v-icon
                >
                E-Cart Booking
              </v-card-title>
            </v-card>
          </router-link>
        </v-flex>
        <v-flex sm12 md12 lg3>
          <router-link to="/contact-list">
            <v-card
                class="mx-auto"
                max-width="340"

            >
              <!--  <v-img
                 src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS7__FnDHgXQYtMK_aD1tp7hvE9IllP4GMO2g&usqp=CAU"
                 height="200px"
               ></v-img> -->
              <v-span style="font-size: 500%;margin:20px;color:#6495ED;"></v-span>
              <v-card-title>
                <v-icon color="#bbbbc6" class="black--text mr-2">contact_phone
                </v-icon
                >
                Emergency Contact

              </v-card-title>
            </v-card>
          </router-link>
        </v-flex>

<!--        <v-flex sm12 md12 lg3>-->
<!--          <v-card-->
<!--              class="mx-auto"-->
<!--              max-width="340">-->
<!--            <v-span style="font-size: 500%;margin:20px;color:#B8860B;"></v-span>-->

<!--            <v-card-title>-->
<!--              <v-icon color="#bbbbc6" class="black&#45;&#45;text mr-2">groups-->
<!--              </v-icon-->
<!--              >-->
<!--              Concession-->
<!--            </v-card-title>-->
<!--          </v-card>-->
<!--        </v-flex>-->


        <v-flex sm12 md12 lg3>
          <router-link to='/station-amenities-list'>
            <v-card
                class="mx-auto"
                max-width="340"

            >
              <!-- <v-img
                src="https://www.4dbrix.com/products/train/210-double-crossover/4dbrix-lego-double-crossover-7996-1.jpg"
                height="200px"
              ></v-img> -->
              <v-span style="font-size: 500%;margin:20px;color:#006400;"></v-span>
              <v-card-title>
                <v-icon color="#bbbbc6" class="black--text mr-2">train
                </v-icon
                >
                Station Amenities

              </v-card-title>
            </v-card>
          </router-link>
        </v-flex>


        <v-flex sm12 md12 lg3>
          <router-link to="/railway-penalty-list">
            <v-card
                class="mx-auto"
                max-width="340"

            >
              <!-- <v-img
                src="https://www.4dbrix.com/products/train/210-double-crossover/4dbrix-lego-double-crossover-7996-1.jpg"
                height="200px"
              ></v-img> -->
              <v-span style="font-size: 500%;margin:20px;color:#006400;"></v-span>
              <v-card-title>
                <v-icon color="#bbbbc6" class="black--text mr-2">accessibility
                </v-icon
                >
                Railway Penalty

              </v-card-title>
            </v-card>
          </router-link>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script type="text/javascript">

export default {
  name: "create_module",
  data: () => {
    return {
      detail_loader: false,
    };
  },

};

</script>
